import { render, staticRenderFns } from "./People.vue?vue&type=template&id=82fda1b2&scoped=true"
import script from "./People.vue?vue&type=script&lang=ts"
export * from "./People.vue?vue&type=script&lang=ts"
import style0 from "./People.vue?vue&type=style&index=0&id=82fda1b2&prod&scoped=true&lang=css"
import style1 from "./People.vue?vue&type=style&index=1&id=82fda1b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82fda1b2",
  null
  
)

export default component.exports